module.exports = __webpack_public_path__ + "img/logo-clearframe.1becdfcc.svg";